import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=ea5dcad2&scoped=true&"
import script from "./Feedback.js?vue&type=script&lang=js&"
export * from "./Feedback.js?vue&type=script&lang=js&"
import style0 from "./Feedback.scss?vue&type=style&index=0&id=ea5dcad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5dcad2",
  null
  
)

export default component.exports